import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const NextEpisodeContentContainer = styled.div<Props>`
  align-items: center;
  display: flex;
  height: 100%;
  padding: 0 ${(props) => (props.focused ? 22 : 20) * Screen.widthRatio}px;

  &:hover {
    padding: 0 ${22 * Screen.widthRatio}px;
  }
`;

export default NextEpisodeContentContainer;
